import styled from 'styled-components';

export const Body = styled.div`
  gap: 16px;
  display: flex;
  min-width: 0;
  flex-direction: column;
  /* The dialog lines its content up at the start; the review fills it
     (Dev visual pass 30 Oct 2026: it shrank to its content). */
  width: 100%;
  align-self: stretch;
`;

export const Intro = styled.p`
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

export const Note = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

export const Warnings = styled.ul`
  gap: 4px;
  margin: 0;
  display: flex;
  padding-left: 20px;
  flex-direction: column;
`;

export const Footer = styled.div`
  gap: 16px;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 767px) {
    flex-direction: column-reverse;
  }
`;

export const Row = styled.div`
  gap: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const LinkButton = styled.button`
  border: 0;
  padding: 0;
  font: inherit;
  cursor: pointer;
  background: none;
  font-weight: 600;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.blue.primary.standard};

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.grey.primary.standard};
  }
`;

export const History = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
`;

export const HistoryEntry = styled.div`
  gap: 4px;
  display: flex;
  padding: 12px 16px;
  border-radius: 12px;
  flex-direction: column;
  overflow-wrap: anywhere;
  background: ${({ theme }) => theme.colors.grey.tertiary.standard};
`;

export const Lines = styled.div`
  gap: 4px;
  display: flex;
  flex-direction: column;
`;

// A list cell clips one line by default; where a line lands may take two.
export const Wrap = styled.span`
  display: block;
  white-space: normal;
  overflow-wrap: anywhere;
`;

export const Pair = styled.div`
  gap: 12px;
  display: grid;
  align-items: start;
  grid-template-columns: 1fr auto;
`;
